import { Link } from "react-router-dom";
import { Container } from "reactstrap";
// import {BiBuildingHouse} from "react-icons/bi";
// import {FaUsers} from "react-icons/fa";
export function RegisterTypeComponent() {

    return (
        <>
            <Container className="d-flex justify-content-center align-item-center mb-5">
                <div className="form-border d-flex flex-column align-items-center">

                    {/* <h4 className="text-center type-register mt-5">
                        เลือกประเภทผู้สมัคร
                    </h4> */}
                    <div className="d-flex justify-content-evenly w-100 my-5 mt-3">
                        <Link
                            to="/registeration/registerType/personal"
                            className="item-system d-flex flex-column justify-content-center align-items-center w-25"
                            style={{ textDecoration: "none", marginTop: "4%" }}>
                            <img src="images/person.png" width="100px" height="auto" />
                            {/* <FaUsers className="user-icon"/> */}
                            <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>บุคคลธรรมดา</span>
                        </Link>

                        <Link
                            to="/registeration/registerType/company"
                            className="item-system d-flex flex-column justify-content-center align-items-center w-25"
                            style={{ textDecoration: "none", marginTop: "4%" }}>
                            <img src="images/building.png" width="100px" height="auto" />
                            {/* <BiBuildingHouse className="user-icon"/> */}
                            <span style={{ fontSize: "1.2rem", fontWeight: "bold" }}>นิติบุคคล</span>
                        </Link>

                    </div>
                </div>
            </Container>
        </>




    );
}
